import React from "react"
import { Flex, Select, Heading } from "@chakra-ui/react"
import { TriangleDownIcon } from "@chakra-ui/icons"

const styles = {
  root: {
    mt: "50px",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  },
  heading: {
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "150%",
    color: "#000000",
    letterSpacing: "0.0015em",
    padding: 0,
    width: "70px",
  },
  select: {
    height: "54px",
    color: "#000000",
    border: "1px solid rgba(0, 0, 0, 0.23)",
  },
}

const FilterBy = ({ options, onChange }) => (
  <Flex sx={styles.root}>
    <Heading sx={styles.heading}>Filter by</Heading>
    <Flex width="90%">
      <Select
        icon={<TriangleDownIcon sx={{ fontSize: "10px" }} />}
        sx={styles.select}
        onChange={onChange}
      >
        {options.map(option => (
          <option id={option.id} value={option.id} key={option.id}>
            {option.name}
          </option>
        ))}
      </Select>
    </Flex>
  </Flex>
)

export default FilterBy
